import { render, staticRenderFns } from "./rewardDialog.vue?vue&type=template&id=4fc4753e&scoped=true&"
import script from "./rewardDialog.vue?vue&type=script&lang=js&"
export * from "./rewardDialog.vue?vue&type=script&lang=js&"
import style0 from "./rewardDialog.vue?vue&type=style&index=0&id=4fc4753e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4753e",
  null
  
)

export default component.exports